import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useIsMobile } from '../utils/responsive';
export function OfferFooter({ settings, styles, onLinkClick, }) {
    const shouldShowFooter = shouldDisplayFooter(settings, styles);
    if (!shouldShowFooter) {
        return null;
    }
    const containerStyles = {
        textAlign: 'center',
        borderTop: '#ddd 1px solid',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 24px',
        fontSize: '12px',
        color: '#666',
        fontFamily: styles.offerText?.font || 'Roboto, sans-serif',
        borderBottomLeftRadius: styles.popup?.borderRadius?.bottom_left
            ? `${styles.popup.borderRadius.bottom_left}px`
            : '8px',
        borderBottomRightRadius: styles.popup?.borderRadius?.bottom_right
            ? `${styles.popup.borderRadius.bottom_right}px`
            : '8px',
    };
    const disclaimerStyles = {
        width: '100%',
        fontSize: '10px',
        textAlign: useIsMobile() ? 'center' : 'left',
        marginBottom: '2px',
        color: '#777',
        display: settings.show_disclaimer && styles.footer?.disclaimer ? 'block' : 'none',
    };
    const linkContainerStyles = {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: useIsMobile() ? 'center' : 'flex-end',
        flexDirection: 'row',
        fontSize: '10px',
        width: '100%',
    };
    const linkStyles = {
        color: '#777',
        textDecoration: 'none',
    };
    const showApxLinks = styles.footer?.show_apx_links ?? true;
    const publisherPrivacyPolicy = styles.footer?.publisher_privacy_policy;
    const publisherName = styles.footer?.publisher_name || 'Publisher';
    return (_jsxs("div", { id: 'adpx_footer-text-container', className: 'adpx_modal-footer', style: containerStyles, children: [settings.show_disclaimer && styles.footer?.disclaimer && (_jsx("div", { id: 'adpx_footer-disclaimer', style: disclaimerStyles, children: styles.footer.disclaimer })), _jsxs("div", { style: linkContainerStyles, children: [showApxLinks && (_jsxs(_Fragment, { children: [_jsx("a", { id: 'adpx_footer-powered-link', href: 'https://momentscience.com/', target: '_blank', rel: 'noopener noreferrer', style: linkStyles, onClick: onLinkClick, children: styles.footer?.text || 'Powered by AdPostX' }), _jsx("span", { children: " - " }), _jsx("a", { id: 'adpx_footer-privacy-link', href: styles.footer?.privacy ||
                                    'https://www.momentscience.com/privacy-policy', target: '_blank', rel: 'noopener noreferrer', style: linkStyles, onClick: onLinkClick, children: "Privacy Policy" })] })), publisherPrivacyPolicy && (_jsxs(_Fragment, { children: [showApxLinks && _jsx("pre", { children: " | " }), _jsxs("a", { id: 'adpx_footer-publisher-privacy-link', href: publisherPrivacyPolicy, target: '_blank', rel: 'noopener noreferrer', style: linkStyles, onClick: onLinkClick, children: [publisherName, " Privacy Policy"] })] }))] })] }));
}
function shouldDisplayFooter(settings, styles) {
    if (settings.embedded?.showFooter === false) {
        return false;
    }
    const hasDisclaimer = !!(settings.show_disclaimer && styles.footer?.disclaimer);
    const hasPublisherPrivacy = !!styles.footer?.publisher_privacy_policy;
    const hasApxLinks = styles.footer?.show_apx_links ?? true;
    return hasDisclaimer || hasPublisherPrivacy || hasApxLinks;
}
